module.exports = __webpack_public_path__ + "img/H2.e64e7058.png";